import GoodAndRetunsController from 'pages/Controller/GoodAndRetunsController';
import React from 'react';
import Select from 'react-select';
import { Grid, Table, TableBody, TableRow, TableCell, TableHead, Paper, Dialog, DialogTitle, DialogContent } from '@mui/material';
import { Box, Button, Card, DialogActions, TableContainer } from '../../../node_modules/@mui/material/index';

import Loader from 'utils/Loader';

function GoodAndReturns() {
  const {
    handleClearButtonClick,
    selectedOption,
    returnOptions,
    value,
    handleChange,
    handleTextareaResize,
    handleProceed,
    onOptionChange,
    getPlaceholder,
    goodsReturnsData,
    deliverySearchError,
    // handleTransfer,

    customeroptions,
    selectedCustomer,
    setSelectedCustomer,
    handleInputChange,

    handleSubmitReturnInfo,

    openDialog,
    selectedMaterials,
    handleViewMaterials,
    handleCloseDialog,

    loading
  } = GoodAndRetunsController();


  const customStyles = {
    option: (provided) => ({
      ...provided,
      zIndex: 999 // Adjust the value as needed
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 1000 // Make sure this value is higher than the table header's z-index
    })
  };

  return (
    <div
      className="bg"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '20px 16px',
      }}
    >
      {loading ? (
        <div className="overlay">
          <Loader />
          <span style={{ marginLeft: '10px' }}>Fetching...</span>
        </div>
      ) : null}

      <div className="cutrange" style={{ width: '100%', maxWidth: 900 }}>
        <span className="font20">GOOD RETURNS</span>
      </div>

      {/* Dropdown centered */}
      {/* <div style={{ width: '100%', maxWidth: 900, marginTop: 16, display: 'flex' }}>
        <div style={{ display: 'flex', flexDirection: "column", justifyContent: "start", alignItems: 'center' }}>
          <label htmlFor="returnOption" style={{ fontWeight: 600 }}>Select Return Option:</label>
          <Grid item xs={12} sm={4} md={4}>
            <Select
              id="returnOption"
              value={selectedOption}
              options={returnOptions}
              onChange={onOptionChange}
              className="inp_text"
              menuPortalTarget={document.body}
              styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
            ></Select>
          </Grid>
        </div>
      </div> */}

      <Card sx={{ width: '100%', maxWidth: 1000, p: 3, mb: 1 }}>
        {/* Dropdown centered */}
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          flexDirection="column"
          sx={{ mt: 2 }}
          spacing={2}
        >
          <Grid
            item
            sm={12}
            md={4}
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Select
              id="returnOption"
              value={selectedOption}
              options={returnOptions}
              onChange={onOptionChange}
              className="inp_text"
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              }}
            />
          </Grid>
        </Grid>


        {/* Centered textarea */}
        <Grid container justifyContent="center" flexDirection="column" style={{ marginTop: 18 }} spacing={2}>
          <Grid item xs={12} sm={12} md={12}>
            <textarea
              name="barcodes"
              value={value}
              className={`form-control inp_text`}
              id="barcodes"
              rows={2}
              cols={50}
              onChange={handleChange}
              onInput={handleTextareaResize}
              autoFocus
              placeholder={getPlaceholder()}
              style={{ width: '100%', boxSizing: 'border-box', resize: 'vertical' }}
            />
            {deliverySearchError ? (
              <div style={{ color: '#d32f2f', fontSize: '12px', marginTop: '6px' }}>
                {deliverySearchError}
              </div>
            ) : null}
          </Grid>

          <Grid item xs={12} sm={12} md={12} display="flex" flexDirection="row" alignItems="end" justifyContent="end">
            <button onClick={handleClearButtonClick} style={{ marginRight: '15px', marginBottom: '10px' }}>
              {'Clear'}
            </button>

            <button style={{ marginRight: '15px', marginBottom: '10px' }} onClick={handleProceed}>
              {'Submit'}
            </button>
          </Grid>
        </Grid>
      </Card>

      {goodsReturnsData && Object.keys(goodsReturnsData).length > 0 && (
        <Card sx={{ width: '100%', maxWidth: 1000, p: 3 }}>
          <div style={{ marginTop: 4 }}>
            <>
              <Box sx={{ display: "flex", mt: 2, justifyContent: "center" }}>
                <div style={{ width: "300px" }}>
                <Select
                  id="dropdown"
                  value={selectedCustomer}
                  isSearchable={true}
                  placeholder="Search Customer"
                  options={customeroptions}
                  styles={customStyles}
                  onInputChange={handleInputChange}
                  onChange={setSelectedCustomer}
                />
                </div>
              </Box>
              <Grid container justifyContent="center" flexDirection="column" style={{ marginTop: 18 }} spacing={2}>
                <Grid item xs={12} sm={12} md={12}>
                  <Card>
                    <TableContainer component={Paper} sx={{ maxHeight: 350 }}>
                      <Table
                        stickyHeader
                        size="small"
                        sx={{
                          tableLayout: 'auto',
                          '& .MuiTableCell-root': {
                            py: 0.75,
                            px: 1,
                            fontSize: '0.78rem',
                            lineHeight: 1.25,
                            whiteSpace: 'normal',
                            wordBreak: 'break-word',
                            overflowWrap: 'anywhere',
                            textOverflow: 'clip',
                            overflow: 'visible',
                            verticalAlign: 'top'
                          }
                        }}
                      >
                        <TableHead>
                          <TableRow>
                            <TableCell align="center">Delivery Number</TableCell>
                            <TableCell align="center">Invoice Number</TableCell>
                            <TableCell align="center">Invoice Date</TableCell>
                            <TableCell align="center">Customer Code</TableCell>
                            <TableCell align="center">Actions</TableCell>
                          </TableRow>
                        </TableHead>

                        <TableBody>
                          {goodsReturnsData.map((row, index) => (
                            <TableRow key={index} hover>
                              <TableCell align="center">{row.deliveryNumber || row.DELIVERY_NUMBER}</TableCell>
                              <TableCell align="center">{row.invoiceNumber || row.INVOICE_NO}</TableCell>
                              <TableCell align="center">{row.invoiceDate || row.INVOICE_DATE}</TableCell>
                              <TableCell align="center">{row.customerCode || row.CUSTOMER_CODE}</TableCell>
                              <TableCell align="center">
                                <Button
                                  variant="outlined"
                                  size="small"
                                  sx={{
                                    width: '72px !important',
                                    minWidth: '72px !important',
                                    height: '32px !important',
                                    px: '10px !important',
                                    py: '4px !important',
                                    fontSize: '0.75rem',
                                    lineHeight: 1,
                                    textTransform: 'none',
                                  }}
                                  onClick={() => handleViewMaterials(row.materialList)}
                                >
                                  View
                                </Button>
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>

                      </Table>
                    </TableContainer>

                  </Card>
                </Grid>

                <Grid item xs={12} sm={12} md={12} display="flex" flexDirection="column" alignItems="end" justifyContent="end">
                  <Button
                    type="button"
                    variant="contained"
                    sx={{ width: "fit-content", px: 10 }}
                    onClick={handleSubmitReturnInfo}
                  >
                    Submit
                  </Button>
                </Grid>
              </Grid>
            </>
          </div>
        </Card>
      )}


      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Material Details</DialogTitle>

        <DialogContent>
          <TableContainer component={Paper}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell align="center">Material Code</TableCell>
                  <TableCell align="center">Material Description</TableCell>
                  <TableCell align="center">Barcode</TableCell>
                  <TableCell align="center">Quantity</TableCell>
                  <TableCell align="center">Cut</TableCell>
                  <TableCell align="center">Division</TableCell>
                  <TableCell align="center">Batch</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {selectedMaterials.length > 0 ? (
                  selectedMaterials.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell align="center">{item.MATERIAL_CODE}</TableCell>
                      <TableCell align="center">{item.MATERIAL_DESC}</TableCell>
                      <TableCell align="center">{item.BARCODE}</TableCell>
                      <TableCell align="center">{item.QUANTITY}</TableCell>
                      <TableCell align="center">{item.CUT_QTY}</TableCell>
                      <TableCell align="center">{item.DIVISON}</TableCell>
                      <TableCell align="center">{item.BATCH}</TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={5} align="center">
                      No Materials Found
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        {/* ✅ Bottom-right Close Button */}
        <DialogActions sx={{ display: "flex", justifyContent: "flex-end" }}>
          <Button
            onClick={handleCloseDialog}
            variant="contained"
            color="primary"
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

    </div>
  );
}

export default GoodAndReturns;
